import { Label } from 'reactstrap';
import { useHiddenSectionsContext } from '../../contexts/HiddenSectionsContext';
import { asQuantity } from '../../utils/formatters';
import SwitchInput from '../basics/SwitchInput';

const HiddenSectionsSwitch = ({ hiddenSectionCount }) => {
  const {
    showHiddenSections,
    setShowHiddenSections,
  } = useHiddenSectionsContext();
  return (
    <div className="d-flex justify-content-between align-items-center">
      <Label className="m-0">
        Include{' '}
        {asQuantity(hiddenSectionCount, {
          unit: 'hidden sections',
          singular: 'hidden section',
        })}
      </Label>
      <SwitchInput
        checked={showHiddenSections}
        onChange={() => setShowHiddenSections(!showHiddenSections)}
      />
    </div>
  );
};

export default HiddenSectionsSwitch;
